import type { Locale } from '@xphoto/shared';

/**
 * Interpolation minimale de gabarits i18n : remplace les jetons `{name}` par les
 * valeurs fournies. Le `t()` du projet ne résout que des clés (pas de variables) ;
 * ce helper reste volontairement simple et sans dépendance.
 *
 * FORMATAGE DES NOMBRES : passer `locale` fait rendre les valeurs numériques avec
 * `toLocaleString(locale)` — `{count}` donne alors `12 345` / `12.345` / `12,345`
 * comme les compteurs de `SortMenu` et `Toolbar`, au lieu du `12345` brut d'un
 * `String(value)`. Sans `locale`, le comportement historique est conservé (les
 * gabarits sans grand nombre n'ont rien à y gagner).
 *
 * Pour un message qui varie AVEC le nombre (« 1 photo » / « 3 photos »), utiliser
 * `tp()` de `useI18n()` — cf. `i18n/plural.ts`.
 */
export function interpolate(
  template: string,
  vars: Record<string, string | number>,
  locale?: Locale,
): string {
  return template.replace(/\{(\w+)\}/g, (match, key: string) => {
    const value = vars[key];
    if (value === undefined) return match;
    return typeof value === 'number' && locale !== undefined
      ? value.toLocaleString(locale)
      : String(value);
  });
}
